<template>
    <div class="header-container">
        <div class="header-left">
            <div class="logo-img">
                <img src="@/assets/img/logo.png" />
            </div>
            <div class="slogin-img">
                <img src="@/assets/img/slogin.png" />
            </div>
        </div>
        <div class="header-right">
            <div class="header-right-tip" @click="popupShow=true">
                <span>当前年级：{{grade}}{{term}}</span>
                <el-icon>
                    <ArrowDown />
                </el-icon>
            </div>
            <div v-if="userInfo.userId && !isVip" class="vip-btn" @click="openPurchase('vip') ">
                <img src="@/assets/img/cwvip.jpg">
            </div>
            <div v-if="userInfo.userId && isVip" class="vip-btn" @click="openPurchase('vip') ">
                <img src="@/assets/img/vipxq.jpg">
            </div>
            <div class="header-right-tip" @click="openPerson" v-if="userInfo.userId">
                <img class="header-right-img" :src="userInfo.avatarUrl" v-if="userInfo.avatarUrl" />
                <img class="header-right-img" src="@/assets/img/xstxico1.png" v-else/>
                <span>{{userInfo.userName || userInfo.userPhone}}</span>
                <el-icon>
                    <Setting />
                </el-icon>
            </div>
            <div class="header-right-tip" @click="loginEvent" v-if="!userInfo.userId">
                <span>您还未登录</span>
                <el-icon>
                    <Setting />
                </el-icon>
            </div>
            <el-dropdown class="dropdown-box" placement="bottom-end" trigger="click" @command="dropdownCommand" v-if="userList.length">
                <span class="el-dropdown-link" style="cursor:pointer">
                    切换学生
                    <el-icon class="el-icon--right">
                        <Switch />
                    </el-icon>
                </span>
                <template #dropdown>
                    <el-dropdown-menu>
                        <el-dropdown-item v-for="item in userList" :key="item.studentId" :command="item">{{item.studentName || item.studentAdminPhone}}</el-dropdown-item>
                    </el-dropdown-menu>
                </template>
            </el-dropdown>
        </div>

        <el-dialog v-model="userShow" append-to-body :show-close="false" top="40px" class="custom-dialog" modal-class="custom-modal-dialog">
            <div class=" header-info ">
                <div class="header-info-top ">
                    <div style="display:flex;align-items: center;">
                        <img class="header-info-avatar " :src="userInfo.avatarUrl" v-if="userInfo.avatarUrl" />
                        <img class="header-info-avatar " src="@/assets/img/xstxico1.png" v-else/>
                        <div>
                            <div class="header-info-name ">
                                <span class="name ">{{userInfo.userName || userInfo.userPhone}}</span>
                            </div>
                            <div class="time " v-show="isVip ">
                                <span class="vip " v-show="isVip ">VIP会员</span>
                                <span>{{userInfo.vipEndDate}} 到期</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="header-vip-time ">
                    <div>
                        <div class="num ">{{userInfo.aiCallRestNum || 0}}</div>
                        <div>AI调用余额</div>
                    </div>
                    <div>
                        <div class="num ">{{userInfo.vipRestNum || 0}}</div>
                        <div>VIP剩余天数</div>
                    </div>
                    <div>
                        <div class="num ">{{userInfo.aiCallNum || 0}}</div>
                        <div>AI调用次数</div>
                    </div>
                </div>
                <div class="header-buy " v-if="userInfo.userId && isVip ">
                    <div @click="openPurchase( 'vip') ">VIP续期</div>
                    <div @click="openPurchase( 'ai') ">AI购买次数</div>
                </div>
                <div class="header-tap ">
                    <div @click="userInfoShow=true ">个人中心</div>
                    <div @click="feedShow=true ">意见反馈</div>
                    <div @click="policyShow=true ">用户协议</div>
                    <div @click="privacyShow=true ">隐私政策</div>
                </div>
                <div class="header-loginout ">
                    <el-button color="#ef8b25 " class="footer-btn1 " @click="loginOut ">退出登陆</el-button>
                </div>
            </div>
        </el-dialog>

        <el-dialog v-model="popupShow " title="年级选择 " width="400px " center>
            <div class="popup-inner grade-inner ">
                <div class="grade-inner-title ">年级</div>
                <div class="grade-inner-box ">
                    <div v-for="item in gradeList " :key="item " :class="[ 'grade-inner-item',gradeActive==item? 'active': ''] " @click="gradeClick(item) ">{{item}}</div>
                </div>
                <div class="grade-inner-title ">学期</div>
                <div class="grade-inner-box ">
                    <div v-for="item in sessionList " :key="item " :class="[ 'grade-inner-item',termActive==item? 'active': ''] " @click="termClick(item) ">{{item}}</div>
                </div>
            </div>
            <template #footer>
                <div class="dialog-footer ">
                    <el-button color="#ef8b25 " class="footer-btn1 " @click="popupConfirm ">确定选择</el-button>
                </div>
            </template>
        </el-dialog>

        <user-info-dialog :popupShow="userInfoShow " v-if="userInfoShow " @close="userInfoShow=false "></user-info-dialog>
        <policy-dialog :popupShow="policyShow " v-if="policyShow " @close="policyShow=false "></policy-dialog>
        <privacy-dialog :popupShow="privacyShow " v-if="privacyShow " @close="privacyShow=false "></privacy-dialog>
        <feedback-dialog :popupShow="feedShow " v-if="feedShow " @close="feedShow=false "></feedback-dialog>
        <purchase-dialog :popupShow="purchaseShow " :type="purchaseType " v-if="purchaseShow " @close="purchaseShow=false " @wxpaySuccess="wxpaySuccess"></purchase-dialog>
    </div>
</template>
<script lang="ts" setup>
import userInfoDialog from "./userInfoDialog.vue"
import policyDialog from "./policyDialog.vue"
import privacyDialog from "./privacyDialog.vue"
import feedbackDialog from "./feedbackDialog.vue"
import purchaseDialog from "./purchaseDialog.vue"
import { getUserInfo, getUserList, setUser, getDict } from "@/api/common.js"
import { ref, onMounted, computed, watch } from 'vue';
import { useStore } from "vuex"
import { useRouter } from 'vue-router';
import { ElMessage } from 'element-plus'
const router = useRouter();
const store = useStore();
const gradeList = ref([])
const sessionList = [
    '上学期',
    '下学期'
]
const popupShow = ref(false)
const userShow = ref(false)
const userInfoShow = ref(false)
const policyShow = ref(false)
const privacyShow = ref(false)
const feedShow = ref(false)
const purchaseShow = ref(false)
const purchaseType = ref('')
const userInfo = computed(() => store.state.userInfo);
const isVip = userInfo.value.vipEndDate ? true : false
const grade = computed(() => store.state.grade)
const term = computed(() => store.state.term)
const gradeActive = ref('')
const termActive = ref('')
const userList = ref([])

watch([grade, term],
    ([newGrade, newTerm]) => {
        gradeActive.value = newGrade;
        termActive.value = newTerm;
    },
    { flush: 'sync',immediate: true }
);

function wxpaySuccess() {
    purchaseShow.value = false
    router.go(0)
}
function loginEvent() {
    store.dispatch('setLoginFlag')
}
function gradeClick(item) {
    gradeActive.value = item;
}
function termClick(item) {
    termActive.value = item;
}
function popupConfirm() {
    popupShow.value = false
    if (gradeActive.value != grade.value || termActive.value != term.value) {
        store.dispatch('setGradeTerm', {
            grade: gradeActive.value,
            term: termActive.value
        })
        router.go(0)
    }
}
function loginOut() {
    sessionStorage.setItem('token', '')
    store.dispatch('setLogin', {});
    store.dispatch('setGradeTerm', {
        grade: '三年级',
        term: '上学期'
    })
    router.replace({ path: '/composition/teaching' }).then(() => {
        location.reload()
    })
}
function openPurchase(type: string) {
    purchaseType.value = type;
    purchaseShow.value = true;
}
function openPerson() {
    if (userShow.value) {
        userShow.value = false
    } else {
        getUserInfo().then(res => {
            store.dispatch('setLogin', res.data);
            store.dispatch('setGradeTerm', {
                grade: res.data.grade || '三年级',
                term: res.data.term || '上学期'
            })
            userShow.value = true
        })
    }
}
function dropdownCommand(item) {
    setUser(item.userId).then(res => {
        ElMessage.success('切换成功！')
        sessionStorage.setItem('token', res.data)
        getUserInfo().then(res => {
            store.dispatch('setLogin', res.data);
            store.dispatch('setGradeTerm', {
                grade: res.data.grade || '三年级',
                term: res.data.term || '上学期'
            })
            router.go(0)
        })
    })
}
function getDictList() {
    getDict({
        dicCode: 'dd_grade'
    }).then(res => {
        gradeList.value = (res.data || []).map(item => {
            return item.dicItemName
        })
    })
}
function getUser() {
    getUserList().then(res => {
        userList.value = res.data || []
    })
}
onMounted(() => {
    getUser()
    getDictList()
})
</script>
<style lang="scss" scoped>
@import "@/style/variable.scss";
.header-container {
    height: 60px;
    box-shadow: 0 3px 6px 0 #c4c0c0;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    z-index: 1;
    position: relative;
    color: #606266;
    font-size: 14px;
    .header-left {
        display: flex;
        .logo-img {
            min-width: 200px;
            height: 60px;
            img {
                width: 100%;
                height: 100%;
            }
        }
        .slogin-img {
            width: auto;
            height: 60px;
            img {
                width: 100%;
                height: 100%;
            }
        }
    }
    .header-right {
        display: flex;
        align-items: center;
        margin-right: 40px;
        &>div+div {
            margin-left: 10px;
        }
        .vip-btn {
            width: auto;
            height: 30px;
            cursor: pointer;
            img {
                width: 100%;
                height: 100%;
            }
        }
        .header-right-tip {
            display: flex;
            align-items: center;
            cursor: pointer;
            position: relative;
            &>span+i {
                margin-left: 6px;
            }
            .header-right-img {
                width: 40px;
                height: 40px;
                margin-right: 4px;
                border-radius: 50%;
            }
        }
    }
}

.header-info {
    width: 260px;
    padding: 20px 15px;
    border-radius: 10px;
    background: url("@/assets/img/bg2.jpg") no-repeat;
    background-size: 100% 100%;
    position: fixed;
    right: 20px;
    top: 63px;
    cursor: default;
    text-align: center;
    .header-info-top {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        outline: none;
        .header-info-avatar {
            width: 50px;
            height: 50px;
            margin-right: 5px;
            border-radius: 50%;
        }
        .header-info-name {
            line-height: 24px;
            .name {
                font-weight: bold;
            }
        }
        .time {
            font-size: 12px;
            color: #2c3e50;
            .vip {
                margin-left: 5px;
                color: $base-color;
            }
        }
        &>div+div {
            margin-left: 10px;
        }
    }
    .header-vip-time {
        border-radius: 10px;
        display: flex;
        background: rgba(255, 255, 255, 0.7);
        padding: 15px 10px;
        font-size: 12px;
        justify-content: space-around;
        margin-top: 10px;
        .num {
            font-weight: bold;
            font-size: 14px;
        }
    }
    .header-buy {
        display: flex;
        justify-content: space-around;
        margin: 10px 0;
        &>div {
            border: 1px solid $base-color;
            background: #fff;
            flex: 1;
            height: 34px;
            line-height: 34px;
            border-radius: 8px;
            font-weight: bold;
            font-size: 14px;
            color: $base-color;
            cursor: pointer;
        }
        &>div+div {
            margin-left: 20px;
        }
    }
    .header-tap {
        line-height: 30px;
        &>div {
            cursor: pointer;
        }
    }
    .header-loginout {
        margin-top: 10px;
        .el-button {
            width: 100%;
        }
    }
}

.grade-inner {
    .grade-inner-title {
        font-weight: bold;
        line-height: 28px;
        color: $base-text-color;
    }
    .grade-inner-box {
        display: flex;
        flex-wrap: wrap;
        margin-top: 6px;
        .grade-inner-item {
            width: 32%;
            height: 40px;
            line-height: 40px;
            text-align: center;
            border-radius: 10px;
            background: #f0f0f0;
            margin: 5px 0;
            margin-right: 2%;
            color: #333;
            cursor: pointer;
            &:nth-of-type(3n) {
                margin-right: 0;
            }

            &.active {
                background: $base-color;
                color: #fff;
            }
        }
    }
}
</style>

<style lang="scss">
.custom-dialog.el-dialog {
    background: transparent;
    box-shadow: none;
}

.custom-dialog .el-dialog__header {
    display: none;
}


.dropdown-box {
    .el-tooltip__trigger::focus-visible {
        outline: unset;
    }
}
</style>

